import React, { useState } from 'react';
import jm, { formatDateTime, photoUrl, referredBy } from '../api';
import CandidateTable, { NameCell, RowActions, StatusBadge } from '../common/CandidateTable';
import Modal from '../common/Modal';
import CandidateSummary, {
  DEMO_SCORE_FIELDS, PERSONAL_SCORE_FIELDS, PHONE_SCORE_FIELDS, ScoreTable,
} from '../common/CandidateSummary';
import useStage from '../common/useStage';

const rejectedBy = (row) => {
  if (!row.rejected_by || !row.rejected_by_first_name) return '—';
  const name = [row.rejected_by_first_name, row.rejected_by_last_name].filter(Boolean).join(' ');
  return `${name} (${row.rejected_by_emp_code})`;
};

/** Rejection is the end of the road — the dialog is read-only history. */
const Rejection = () => {
  const [noop] = useState(null);
  const { rows, loading, editing, detail, detailLoading, openEdit, closeEdit } =
    useStage(jm.rejected, async () => noop);

  const columns = [
    { key: 'action', label: 'Action', search: false, sortable: false, render: (row) => <RowActions row={row} onEdit={openEdit} /> },
    { key: 'job_title', label: 'Job Title' },
    { key: 'first_name', label: 'Candidate Name', render: (row) => <NameCell row={row} /> },
    { key: 'Referred_others', label: 'Referred By', render: referredBy, sortValue: referredBy },
    { key: 'email', label: 'Email' },
    { key: 'status', label: 'Status', search: false, sortable: false, render: () => <StatusBadge label="Rejected" tone="danger" /> },
    { key: 'stage_notes', label: 'Reason' },
    { key: 'rejected_by_first_name', label: 'Rejected By', render: rejectedBy, sortValue: rejectedBy },
    { key: 'rejected_on', label: 'Rejected On', render: (row) => formatDateTime(row.rejected_on) },
  ];

  return (
    <>
      <CandidateTable
        title="Rejection"
        rows={rows}
        columns={columns}
        loading={loading}
        emptyText="No rejected candidates."
        exportName="rejected_candidates"
      />

      <Modal
        show={!!editing}
        title={editing ? `${editing.first_name} ${editing.last_name || ''}` : ''}
        subtitle={editing ? editing.job_title : ''}
        photo={photoUrl(editing?.emp_img)}
        onClose={closeEdit}
      >
        {detailLoading && <div className="text-center py-4">Loading…</div>}

        {!detailLoading && detail && (
          <>
            <CandidateSummary candidate={detail.application} />

            <ScoreTable title="Phone Interview" fields={PHONE_SCORE_FIELDS} row={detail.shortlisted} total={detail.scores.phone} />
            <ScoreTable title="Demo" fields={DEMO_SCORE_FIELDS} row={detail.demo} total={detail.scores.demo} />
            <ScoreTable title="Personal Interview 1" fields={PERSONAL_SCORE_FIELDS} row={detail.interview} total={detail.scores.personal} />
            <ScoreTable title="Final Interview" fields={PERSONAL_SCORE_FIELDS} row={detail.final} total={detail.scores.final} />
            <ScoreTable title="Recruitment" fields={PERSONAL_SCORE_FIELDS} row={detail.recruitment} total={detail.scores.recruitment} />

            <div className="alert alert-danger mb-0">
              <strong>Rejected.</strong>{' '}
              {detail.rejected?.notes ? `Reason: ${detail.rejected.notes}` : 'No reason was recorded.'}
            </div>
          </>
        )}
      </Modal>
    </>
  );
};

export default Rejection;
